$(document).ready(function () {
  // Sidebar close functionality
  $(".sidebar-close").on("click", function () {
    $(".sidebar-qr").fadeOut(300);
  });

  // Register form submission
  $("#registerForm").on("submit", function (e) {
    e.preventDefault();

    var username = $('input[name="username"]').val();
    var name = $('input[name="name"]').val();
    var mobile = $('input[name="mobile"]').val();
    var password = $('input[name="password"]').val();
    var confirmPassword = $('input[name="confirmPassword"]').val();

    if (!username || !name || !mobile || !password) {
      alert("请填写所有必填项");
      return;
    }

    if (password !== confirmPassword) {
      alert("两次输入的密码不一致");
      return;
    }

    // Submit logic here
    console.log("Form submitted");
  });

  // Verify code click to refresh
  $(".verify-code").on("click", function () {
    var timestamp = new Date().getTime();
    $(this).attr("src", "/member/captcha?" + timestamp);
  });

  // Initialize verify code
  if ($(".verify-code").length) {
    $(".verify-code").attr("src", "/member/captcha?" + new Date().getTime());
  }
});
